import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoPatientInsuranceQuestionModalTemplate } from 'themes/application/niko-patient/components';
import { NikoPatientInsuranceQuestionModalStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore, componentProps) => new NikoPatientInsuranceQuestionModalStore(rootStore, componentProps), 'nikoPatientInsuranceQuestionModalStore')
@observer
class NikoPatientInsuranceQuestionModal extends React.Component {
    render() {
        return <NikoPatientInsuranceQuestionModalTemplate {...this.props} />
    }
}

export default NikoPatientInsuranceQuestionModal;